module.exports = "<div class=\"top-bar\">\r\n  <h1>Zonifero Services</h1>\r\n  <span class=\"logout-link\" routerLink=\"/auth/logout\">{{ 'logout' | translate}}</span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/container/views/TopBarComponent/topBar.component.html
// module id = ./src/app/modules/container/views/TopBarComponent/topBar.component.html
// module chunks = main